<template>
  <v-app>
    <v-toolbar color="primary" class="toolbar">
      <v-container fluid pa-0 class="my__toolbar">
        <v-row class="align-center justify-center row">
          <v-col class="col-4 col-md-5 disappear-mobile">
            <v-btn href="/" color="white" class="navbar-buttons primary--text">
              <v-icon>keyboard_arrow_left</v-icon>Voltar
            </v-btn>
            <!-- <v-btn to="/sobre" color="white" class="navbar-buttons primary--text">
              <img
                :src="require('../../assets/icon_ondivan.png')"
                class="mr-2"
                style="width: 20px;"
              />
              Sobre Nós
            </v-btn> -->
          </v-col>
          <v-col class="col-8 col-md-2">
            <v-row class="align-md-center justify-md-center row">
              <img :src="require('../../assets/ondivan_marca_white.svg')" width="70%;" />
            </v-row>
          </v-col>
          <v-col class="col-5 col-md-5 d-none d-md-block disappear-mobile"></v-col>
        </v-row>
      </v-container>
    </v-toolbar>

    <section>
      <v-container>
        <v-row class="wrap justify-center">
          <v-col class="col-12 col-md-10">
            <h1 class="primary--text mt-3">Termos de Uso</h1>
            <hr class="primary--lightGray mt-3 mb-3" />
            <p class="primary--lightGray">
              1. Âmbito.<br />
              Os presentes Termos e Condições Gerais de Uso (denominado somente “Termos de Uso” ou
              “Termos”) vinculam todas as atividades desenvolvidas e serviços oferecidos pelo
              ‘’ONDIVAN’’ (assim denominada a seguir ou, simplesmente, “Plataforma”) aos PACIENTES.
            </p>
            <p class="primary--lightGray">
              Plataforma que é de propriedade da Inês Cristina Miranda Mata Cunha da Silva, e está
              sob sua responsabilidade e gestão.
            </p>
            <p class="primary--lightGray">
              2. Atuação.<br />
              O ONDIVAN é uma Plataforma que faz a intermediação de consultas entre PACIENTES e
              PSICÓLOGOS. Além disso, a Plataforma oferece a possibilidade do PSICÓLOGO administrar
              o seu consultório online e dispor de serviços como marcação, reagendamento, registo do
              prontuário e visualização dos seus dados financeiros.
            </p>
            <p class="primary--lightGray">
              3. Sujeitos.<br />
              Os PACIENTES deverão ser maiores de 18 (dezoito) anos de idade ou devem estar
              acompanhados dos responsáveis legais para acederem ao ONDIVAN.
            </p>
            <p class="primary--lightGray">
              4. Adesão e Aceite.<br />
              Pelo presente instrumento, os PACIENTES e PSICÓLOGOS concordam que:
            </p>
            <p class="primary--lightGray">
              Deverão aceitar os Termos de Uso e Política de Privacidade do ONDIVAN, para fins de
              inscrição, controle de acesso e execução de melhorias na Plataforma;
            </p>
            <p class="primary--lightGray">
              Clicando na caixa de aceitação dos Termos devem aderir e concordar em se submeter ao
              disposto nos presentes Termos;
            </p>
            <p class="primary--lightGray">
              5. Violação das Condições.<br />
              Na eventualidade de um PACIENTE ou PSICÓLOGO descumprir quaisquer condições aqui
              previstas, o ONDIVAN dispõe do direito de encerrar suas respetivas contas e suspender
              ou anular o seu acesso à Plataforma, sem necessidade de aviso prévio.
            </p>
            <p class="primary--lightGray">
              6. Modificações.<br />
              O ONDIVAN apresenta o direito de, a qualquer momento, modificar os Termos de Uso,
              sempre com o envio de avisos para ciência do PACIENTE, sem qualquer responsabilização
              do ONDIVAN devido a:
            </p>
            <p class="primary--lightGray">
              7. Dinâmica.<br />
              Após a realização de cadastro e aceite aos presentes Termos de Uso e Política de
              Privacidade, os PACIENTES poderão começar a buscar por PSICÓLOGOS que trabalhem com a
              especialidade pretendida, entrar em contacto e fazer uma reserva para data e horário
              definidos em consenso.
            </p>
            <p class="primary--lightGray">
              7.1. Contratação. Após o contacto entre o PACIENTE e o PSICÓLOGO, caso haja
              compatibilidade entre ambos, haverá a contratação através da Plataforma ONDIVAN.
            </p>
            <p class="primary--lightGray">
              7.2. Pagamento. O PACIENTE realizará o pagamento através da Plataforma Stripe, que
              será responsável pelo armazenamento de dados financeiros deste e da emissão de notas
              fiscais para os clientes.
            </p>
            <p class="primary--lightGray">
              7.3. Avaliação da Experiência. O PACIENTE poderá avaliar o trabalho do PSICÓLOGO e
              atribuir notas de 1 a 5.
            </p>
            <p class="primary--lightGray">
              8. Incorreção de Informações Cadastrais.<br />
              O PACIENTE ou PSICÓLOGO, para utilizar os Serviços da Plataforma, deverá prestar as
              informações acima exigidas no momento do cadastro.
            </p>
            <p class="primary--lightGray">
              8.1. O ONDIVAN se reserva o direito de impedir, a seu critério, novos cadastros, ou
              cancelar os já efetuados, em caso de ser detectada anomalia que considere, em sua
              análise, revestida de erro grave ou demonstre tentativa deliberada de burlar as regras
              aqui descritas, obrigatórias para todo PACIENTE. Também atuará o ONDIVAN de tal forma
              caso verifique descumprimento, pelo PACIENTE, de qualquer obrigação prevista nos
              Termos de Uso.
            </p>
            <p class="primary--lightGray">
              9. Os cadastros na plataforma são individuais e intransferíveis, devendo o ONDIVAN ser
              imediatamente notificado sobre qualquer uso não autorizado de conta de PACIENTE ou
              PSICÓLOGO, em tempo hábil, não sendo o ONDIVAN responsável por quaisquer prejuízos ou
              danos oriundos do uso de “login” e senha por terceiro, com ou sem o consentimento do
              usuário.
            </p>
            <p class="primary--lightGray">
              9.1. Os PACIENTES e PSICÓLOGOS deverão: (i) Ser cuidadosos com os dados de sua
              identificação individual sempre que acessarem a Internet; (ii) Tomar outras medidas
              necessárias para se protegerem de danos, inclusive fraudes online e off-line; (iii)
              Ser diligentes no uso do conteúdo disponibilizado no ONDIVAN, sabendo de suas
              responsabilidades; e (iv) Cumprir rigorosamente todas as determinações destes Termos
              de Uso.
            </p>
            <p class="primary--lightGray">
              10. Obrigações dos Sujeitos <br />
              Todo o PACIENTE e PSICÓLOGO está obrigado a respeitar estes termos de uso e as leis
              que regem a sua utilização, exclusivamente utilizando-a para os fins a que se destina.
              O PACIENTE obriga-se, ainda, a:
            </p>
            <p class="primary--lightGray">
              Não utilizar o ONDIVAN de qualquer outra forma que afete sua disponibilidade de uso
              por outro PACIENTE, ou de qualquer outra forma que possa danificar, desativar, ou
              sobrecarregar os servidores ou redes;
            </p>
            <p class="primary--lightGray">
              Não utilizar o ONDIVAN para qualquer propósito que seja ilícito ou proibido pelos
              termos de uso e/ou pelas normas aplicáveis;
            </p>
            <p class="primary--lightGray">
              Autorizar que o ONDIVAN possa enviar comunicações por e-mail, telefone ou mensagens
              instantâneas, inclusive de caráter publicitário;
            </p>
            <p class="primary--lightGray">Apresentar comportamento honesto e de boa fé;</p>
            <p class="primary--lightGray">
              O PSICÓLOGO declara expressamente e se compromete a seguir todas as leis,
              regulamentos, decisões judiciais e demais normas éticas e disciplinares a que estiver
              sujeito, de acordo com o Conselho de Psicologia ao qual está filiado.
            </p>
            <p class="primary--lightGray">
              11. Obrigações da plataforma <br />
              É de obrigação do ONDIVAN:
            </p>
            <p class="primary--lightGray">
              Disponibilizar contacto da Terapeuta Chefe para esclarecer dúvidas que não sejam
              respondidas pelo FAC ou pelos termos expostos.
            </p>
            <p class="primary--lightGray">
              Manter, segundo seu julgamento e possibilidades de mercado, a atualização constante da
              plataforma visando seu aperfeiçoamento e adaptação às novas tecnologias disponíveis;
            </p>
            <p class="primary--lightGray">
              Proteger a confidencialidade de todas as informações dos PACIENTES;
            </p>
            <p class="primary--lightGray">
              Disponibilizar contacto da Terapeuta Chefe para sanar dúvidas que não sejam
              respondidas pelo FAC ou pelos termos expostos.
            </p>
            <p class="primary--lightGray">
              12. Idoneidade <br />
              Os PACIENTES e PSICÓLOGOS declaram, ao consentir com este documento para utilizar a
              Plataforma, que detém idoneidade incólume, ficando ciente, desde já, que as
              informações cadastrais falsas ou inverídicas registradas ou fornecidas durante o
              processo eletrônico de contratação de serviços podem constituir crime.
            </p>
            <p class="primary--lightGray">
              13. Restrições <br />
              Não é permitido aceder a áreas de programação do ONDIVAN, ao seu banco de dados ou
              qualquer outro conjunto de informações que faça parte da atividade de webmastering,
              realizar ou permitir que se realize qualquer tipo de engenharia reversa, tradução,
              descompilação, cópia, modificação, reprodução, locação, sublocação, sublicenciamento,
              publicação, divulgação, transmissão, empréstimo, distribuição ou, de qualquer outra
              forma, a disposição de ferramentas de consulta deste website e das suas
              funcionalidades para terceiros sem a prévia e expressa autorização do ONDIVAN, ficando
              sujeito quem o fizer a penalidades da legislação brasileira, sem prejuízo da obrigação
              de reparar os danos que causarem. Esta restrição inclui qualquer tentativa de
              incorporar quaisquer informações da plataforma em qualquer outro diretório, produto ou
              serviço.
            </p>
            <p class="primary--lightGray">
              14. Remuneração <br />
              O PSICÓLOGO poderá estipular o preço da consulta a ser realizada em favor do PACIENTE,
              a qual estará sujeita à moderação da Plataforma ONDIVAN, que recolherá taxa de
              moderação.
            </p>
            <p class="primary--lightGray">
              15. Disponibilidade <br />
              A plataforma está disponível para uso dos PACIENTES e é oferecida "no estado em que se
              encontra" e "conforme disponível". O ONDIVAN declina qualquer responsabilidade por
              garantias implícitas de comerciabilidade, adequação a um determinado fim e de retorno
              financeiro. Além disso, o ONDIVAN não garante que os serviços serão fornecidos sem
              interrupções ou erros. O PACIENTE aceita que todo o risco decorrente da sua utilização
              do ONDIVAN é da sua exclusiva responsabilidade.
            </p>
            <p class="primary--lightGray">
              16. Responsabilidade <br />
              O ONDIVAN não será responsável por quaisquer perdas ou danos sofridos, resultantes de:
              (i) qualquer informação errada ou incompleta que seja fornecida por um PACIENTE ou
              PSICÓLOGO; (ii) qualquer fraude, declaração fraudulenta ou violação do dever, ou
              violação de qualquer uma das condições por um PACIENTE ou PSICÓLOGO; (iii) falhas nas
              conexões; (iv) problemas no processamento de dados por culpa de terceiros; (v) por
              ações do PACIENTE ou PSICÓLOGO no sistema, tipos de dados visualizados ou relatórios
              gerados pelos mesmos.
            </p>
            <p class="primary--lightGray">
              17. Violação de Direito de Terceiros<br />
              O ONDIVAN não se responsabilizará perante qualquer PACIENTE ou PSICÓLOGO em relação a
              qualquer violação de direito de terceiros.
            </p>
            <p class="primary--lightGray">
              18. Danos <br />
              Em nenhum caso, o ONDIVAN será responsável por danos indiretos, incidentais,
              especiais, exemplares, punitivos ou consequentes, incluindo, danos pessoais ou à
              propriedade, relacionados com, ou de outra forma resultantes, de qualquer uso da
              plataforma que o PACIENTE ou PSICÓLOGO possa sofrer devido às ações realizadas ou não
              realizadas através desta, ainda que decorrentes da conduta de terceiros.
            </p>
            <p class="primary--lightGray">
              19. Indenização <br />
              Os PACIENTES ou PSICÓLOGOS indenizarão o ONDIVAN, diretores, administradores,
              colaboradores, representantes e empregados por qualquer demanda promovida por
              terceiros decorrentes de suas atividades na Plataforma, e pelo descumprimento dos
              termos de uso e condições e demais políticas da mesma, e ainda pela violação de
              qualquer lei ou direitos de terceiros, incluindo honorários advocatícios.
            </p>
            <p class="primary--lightGray">
              20. Inativação do Registo/Inscrição, Dúvidas e Sugestões <br />
              Em caso de inativação da conta, dúvida ou sugestões sobre os Termos de Uso do ONDIVAN
              ou qualquer outra informação, o PACIENTE poderá entrar em contacto com os
              administradores através do e-mail
              <a href="mailto: contacto@ondivan.com"> contacto@ondivan.com </a>
              ou de Formulário disponibilizado na Plataforma.
            </p>
            <p class="primary--lightGray">
              21. Vedação e inativação de cadastro <br />
              Como forma de manter a confiança e respeito nesta Plataforma, serão vedados atos
              ilegais ou incompatíveis com a proposta de zelar pela prestação dos serviços de
              qualidade. Assim, poderá resultar em suspensão ou inativação do cadastro de PACIENTE
              que incorrer em qualquer das hipóteses elencadas abaixo:
            </p>
            <p class="primary--lightGray">
              Promoção da violência e/ou discriminação, baseada em questões de raça, sexo, religião,
              nacionalidade, orientação sexual ou de qualquer outro tipo;
            </p>
            <p class="primary--lightGray">Manifestações de caráter político;</p>
            <p class="primary--lightGray">
              Violação de leis sobre a propriedade intelectual, tais como cópias não autorizadas,
              utilização de imagens, sons, movimentos ou textos sem autorização do autor, sejam elas
              marcas, réplicas e/ou falsificações;
            </p>
            <p class="primary--lightGray">
              22. Aperfeiçoamento <br />
              Os PACIENTES concordam que todo e qualquer sistema, plataforma ou serviço,
              independentemente de seu produtor ou características, é uma espécie de produto que
              está sempre em atualização e aperfeiçoamento, possuindo, constante e
              incondicionalmente, aspectos a serem melhorados, o que não pode ser considerado em si
              como falha ou defeito.
            </p>
            <p class="primary--lightGray">
              23. Erros de Funcionamento <br />
              Eventuais erros no funcionamento da Plataforma serão corrigidos o mais breve possível,
              durante o período que for necessário para manutenção. A ONDIVAN não pretende que o
              funcionamento do servidor da Plataforma, bem como de seu sistema, do seu banco de
              dados, software e de seu website, sejam livres de erros, falhas ou de interrupções.
            </p>
            <p class="primary--lightGray">
              24. Utilização da Propriedade Intelectual.<br />
              O uso comercial da expressão "ONDIVAN", como marca, nome empresarial ou nome de
              domínio, e o logotipo são de propriedade exclusiva dos proprietários do ONDIVAN,
              conforme disposto no respectivo ato constitutivo da organização. Da mesma forma,
              direitos autorais e outros direitos passíveis de protecção por propriedade industrial
              como estrutura, os conteúdos das telas relativas à Plataforma, assim como os programas
              relacionados a mesma, software, website, bancos de dados, redes e arquivos. Todos os
              direitos estão protegidos, no Brasil e internacionalmente por leis e tratados
              internacionais de direito autoral, marcas, patentes, modelos e desenhos industriais.
              Aos proprietários do ONDIVAN reservam-se todos os direitos relativos a autorias,
              marcas, patentes, modelos e desenhos industriais, quer sejam de sua propriedade ou
              licenciados em seu favor, a si.
            </p>
            <p class="primary--lightGray">
              24.1. Não é permitido reproduzir, duplicar, copiar, vender, revender, visitar, ou de
              qualquer outra forma explorar para fins comerciais o conteúdo da Plataforma sem o
              prévio consentimento escrito dos proprietários do ONDIVAN. Particularmente, é
              expressamente proibida a utilização de mineração de dados, robôs, ou outras
              ferramentas de coleta e extração de dados para extrair, de forma isolada ou
              recorrente, qualquer parte substancial da Plataforma visando sua reutilização.
            </p>
            <p class="primary--lightGray">
              25. Relações com Terceiros <br />
              A Plataforma poderá fornecer links de acesso a outros websites, o que não significa
              que esses sites sejam de propriedade ou operados pelo ONDIVAN. Como não possui
              controle sobre esses sites, o ONDIVAN não será responsável pelos conteúdos, práticas e
              serviços ofertados nos mesmos. A presença de links para outros sites não implica
              relação de sociedade, de supervisão, de cumplicidade ou solidariedade do ONDIVAN para
              com esses sites e seus conteúdos.
            </p>
            <p class="primary--lightGray">
              26. Política de Cancelamento e Remarcação <br />
              A política de cancelamento ou remarcação de consultas online é permitida tanto para
              PSICÓLOGOS quanto PACIENTES, mediante a retenção de 5% referente ao valor da sessão.O
              PSICÓLOGO pode remarcar ou cancelar até 24 horas antes da sessão, após esse período
              pagará uma taxa de cancelamento. O PACIENTES poderá cancelar ou remarcar até 48 horas
              antes da sessão, após esse período pagará uma taxa de cancelamento de 5% referente ao
              valor da sessão. <br />
              Ao cancelar um agendamento na plataforma @Ondivan, os valores pagos através dos
              métodos de pagamento ''Débito Direto (SEPA)'' e ''Multibanco'' serão devolvidos via
              Stripe. No entanto, será descontada uma percentagem do valor da consulta. Para
              agendamentos via Débito Direito (SEPA), serão 0.8% do valor da consulta mais 0.25
              cêntimos, enquanto para Multibanco serão 2,95% do valor da consulta mais 0,25
              cêntimos.<br />
              Acerca do processo do retorno/devolução, o cancelamento da consulta realizada com a
              forma de pagamento Débito Direto (SEPA) será devolvido através do sistema do @Ondivan,
              enquanto o retorno realizado via Multibanco será feito através da Stripe, que irá
              entrar em contato com o paciente para realizar a transação.
            </p>
            <p class="primary--lightGray">
              27. Advertências e suspensão <br />
              Sem prejuízo de outras medidas cabíveis, o ONDIVAN poderá advertir, suspender,
              temporária ou definitivamente, o acesso de um PACIENTE ou PSICÓLOGO, a qualquer tempo,
              se:<br />
              A) não cumprir com qualquer dispositivo dos termos de uso ou da política de
              privacidade;<br />
              B) descumprir com quaisquer de suas obrigações ou proibições assumidas ao utilizar os
              serviços da plataforma;<br />
              C) utilizar, sem autorização, nome e/ou marca do ONDIVAN, em parte ou na sua
              totalidade, e violar direitos de propriedade intelectual do ONDIVAN;<br />
              D) não puder ser verificada a identidade ou se qualquer informação fornecida por este
              estiver incorreta;<br />
              E) Apresentem comportamentos inadequados nos espaços de comunicação da comunidade
              ONDIVAN;
            </p>
            <p class="primary--lightGray">
              28. Tratamento dos Dados Pessoais <br />
              Para que a Plataforma tenha qualidade e para que o PACIENTE possa obter resultados de
              forma rápida e segura, é necessário o fornecimento de dados pessoais, nos termos
              dispostos na Política de Privacidade do ONDIVAN.
            </p>
            <p class="primary--lightGray">
              29. Nulidades <br />
              Se qualquer cláusula deste instrumento for considerada ilegal, inválida ou
              inaplicável, no seu todo ou em parte, ao abrigo de qualquer lei, essa cláusula ou
              parte do mesmo será nesta exata medida entendida como não fazendo parte dos Termos de
              Uso, sendo que a legalidade, validade e aplicabilidade das demais cláusulas não serão
              afetadas.
            </p>
            <p class="primary--lightGray">
              30. Lei e Jurisdição <br />
              Os presentes Termos de Uso são regidos pelas leis brasileiras, tendo como definido o
              foro da Comarca de Salvador, Bahia, como competente para dirimir eventuais
              controvérsias oriundas destes, em prejuízo de qualquer outro, por mais privilegiado
              que seja ou venha a ser, devendo-se dar prioridade, sempre, às tentativas de resolução
              por autocomposição.
            </p>
            <p class="primary--lightGray">Criado em 01 de setembro de 2019.</p>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <v-footer height="auto" color="primary">
      <v-row class="align-center justify-center ma-0">
        <v-col class="py-3 text-center white--text col-12 col-md-2" style="font-size: 12px">
          <img :src="require('../../assets/ondivan_marca_white.svg')" width="180px;" />
        </v-col>
        <v-col class="py-3 text-center white--text col-12 col-md-2" style="font-size: 14px">
          <strong>RESPONSÁVEL TÉCNICO:</strong>
          <br />Inês Mata {{ $t('footer.opp') }}
        </v-col>
        <v-col
          class="py-3 d-flex text-center align-center justify-center col-12 col-md-2"
          style="font-size: 14px"
        >
          <div v-if="lang === 'pt'">
            <a href="https://www.livroreclamacoes.pt/" target="_blank" class="white--text">
              Livro de Reclamações
            </a>
          </div>
          <!-- <div>
            <a href="/privacidade" class="white--text">Política de privacidade</a>
          </div> -->
        </v-col>
        <v-col class="py-3 text-center col-12 col-md-2" style="font-size: 14px">
          <a target="blank" href="https://fb.me/ondivan.net">
            <img :src="require('../../assets/facebook_icon.png')" width="40px;" />
          </a>
          <a target="blank" href="https://www.instagram.com/on.divan/">
            <img :src="require('../../assets/instagram_icon.png')" width="40px;" class="ml-4" />
          </a>
        </v-col>
        <v-col
          class="pa-3 row text-center col-12 col-md-2 align-center d-flex"
          style="font-size: 12px"
        >
          <div class="d-flex row align-center justify-center">
            <div>
              <p class="mb-1 mr-1 white--text" style="font-size: 1.2rem">
                <strong>Email:</strong>geral@ondivan.net
              </p>
            </div>
            <div>
              <!-- <a target="blank" href="https://www.easypay.pt/">
              <img :src="require('../../assets/easypay.jpg')" style="width: 100px;" />
              </a> -->
            </div>
          </div>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import getLanguage from '../../utils/getLanguage';

export default {
  data() {
    return {
      lang: '',
    };
  },

  created() {
    this.lang = getLanguage(window.location.href);
  },
};
</script>

<style lang="css" scoped>
.toolbar {
  height: auto;
}

.v-toolbar__content {
  height: auto !important;
}

.my__toolbar {
  height: auto;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@media screen and (max-width: 420px) {
  .my__toolbar img {
    width: 50%;
  }
}
</style>
